export default {"src":"/_next/static/media/Skyline.b595c077.gif","height":291,"width":2950,"blurWidth":0,"blurHeight":0};